import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'referrals.pageTitle',
    defaultMessage: 'Referrals'
  },
  sectionHeading: {
    id: 'referrals.sectionHeading',
    defaultMessage: 'Refer a colleague'
  },
  rewardExplainer: {
    id: 'referrals.rewardExplainer',
    defaultMessage:
      'Refer a fellow doctor to Sijilo and get {days} extra days added to your plan once they join.'
  },
  statTotal: {
    id: 'referrals.statTotal',
    defaultMessage: 'Referrals sent'
  },
  statPending: {
    id: 'referrals.statPending',
    defaultMessage: 'Awaiting review'
  },
  statDaysEarned: {
    id: 'referrals.statDaysEarned',
    defaultMessage: 'Days earned'
  },
  formHeading: {
    id: 'referrals.formHeading',
    defaultMessage: 'Who would you like to refer?'
  },
  refereeName: {
    id: 'referrals.refereeName',
    defaultMessage: "Doctor's name"
  },
  refereeEmail: {
    id: 'referrals.refereeEmail',
    defaultMessage: 'Email'
  },
  refereePhone: {
    id: 'referrals.refereePhone',
    defaultMessage: 'Phone'
  },
  contactHint: {
    id: 'referrals.contactHint',
    defaultMessage: 'Fill in at least one of email or phone.'
  },
  sendReferral: {
    id: 'referrals.sendReferral',
    defaultMessage: 'Send referral'
  },
  sendingText: {
    id: 'referrals.sendingText',
    defaultMessage: 'Sending...'
  },
  referralSentSuccess: {
    id: 'referrals.referralSentSuccess',
    defaultMessage: 'Referral sent. We will reach out to your colleague soon.'
  },
  referralSentError: {
    id: 'referrals.referralSentError',
    defaultMessage: 'Something went wrong, please try again later'
  },
  nameRequired: {
    id: 'referrals.nameRequired',
    defaultMessage: 'Required'
  },
  contactRequired: {
    id: 'referrals.contactRequired',
    defaultMessage: 'Enter an email or a phone number'
  },
  invalidEmail: {
    id: 'referrals.invalidEmail',
    defaultMessage: 'Enter a valid email address'
  },
  invalidPhone: {
    id: 'referrals.invalidPhone',
    defaultMessage: 'Enter a valid phone number'
  },
  selfReferral: {
    id: 'referrals.selfReferral',
    defaultMessage: 'You cannot refer yourself'
  },
  duplicateReferral: {
    id: 'referrals.duplicateReferral',
    defaultMessage: 'You have already referred this colleague'
  },
  yourReferrals: {
    id: 'referrals.yourReferrals',
    defaultMessage: 'Your referrals'
  },
  noReferrals: {
    id: 'referrals.noReferrals',
    defaultMessage: 'You have not referred anyone yet.'
  },
  statusPending: {
    id: 'referrals.statusPending',
    defaultMessage: 'Pending'
  },
  statusRewarded: {
    id: 'referrals.statusRewarded',
    defaultMessage: '{days} days added'
  },
  statusRejected: {
    id: 'referrals.statusRejected',
    defaultMessage: 'Not eligible'
  }
})
